export default (property) => property && typeof property === "object" && "$c" in property;
